import { render } from "./DeviceCard.vue?vue&type=template&id=b3dd973c&scoped=true"
import script from "./DeviceCard.vue?vue&type=script&lang=js"
export * from "./DeviceCard.vue?vue&type=script&lang=js"

import "./DeviceCard.vue?vue&type=style&index=0&id=b3dd973c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3dd973c"]])

export default __exports__